import * as React from "react";
import { BasicButton } from "./BasicButton";
import { ButtonColor } from "./types";
import classNames from "classnames";
import { Image } from "../image/Image";
import { Glyphicon } from "react-bootstrap";
import { GlyphIcon } from "../icons";

export interface ImageButtonProps {
    imagePath?: string;
    color?: ButtonColor;
    className?: string;
}

export const ImageButton = (props: ImageButtonProps) => {
    const { imagePath, color = ButtonColor.PRIMARY, className: classnameProps, ...rest } = props;
    const className = classNames(classnameProps, "square-button");

    return (
        <BasicButton color={color} className={className} {...rest}>
            {imagePath ? (
                <Image imageUrl={`url(${imagePath})`} />
            ) : (
                <Glyphicon glyph={GlyphIcon.ALERT} color={ButtonColor.DANGER} />
            )}
        </BasicButton>
    );
};
